import { KnowledgebaseQuestion } from './KnowledgebaseQuestion';
import { KnowledgebaseQuestionAndInfoQuestion } from './KnowledgebaseQuestionAndInfoQuestion';
import { ViewableQuestion } from '../types/global';

interface QuestionnaireDisplayProps {
  currentQuestionId: string;
  nextQuestionId: string | null;
  previousQuestionId: string | null;
  fullCurrentQuestion: ViewableQuestion | undefined;
  fullNextQuestion: ViewableQuestion | null;
  fullPreviousQuestion: ViewableQuestion | null;
  shouldDisplayPreviousQuestion: boolean;
  currentPage: string;
  showErrors: boolean;
  invalidQuestions: string[];
  resetErrors: () => void;
  setHasFreshSelection: (hasFreshSelection: boolean) => void;
  setIsQuestionExiting: (exiting: boolean) => void;
}

export const QuestionnaireDisplay = ({
  currentQuestionId,
  nextQuestionId,
  previousQuestionId,
  fullCurrentQuestion,
  fullNextQuestion,
  fullPreviousQuestion,
  shouldDisplayPreviousQuestion,
  currentPage,
  showErrors,
  invalidQuestions,
  resetErrors,
  setHasFreshSelection,
  setIsQuestionExiting,
}: QuestionnaireDisplayProps) => {
  return (
    <>
      {/* Case 1: Current question is INFO - display it with next question */}
      {fullCurrentQuestion?.format === 'INFO' &&
      nextQuestionId &&
      fullNextQuestion ? (
        <KnowledgebaseQuestionAndInfoQuestion
          infoQuestionId={currentQuestionId}
          normalQuestionId={nextQuestionId}
          showErrors={showErrors}
          invalidQuestions={invalidQuestions}
          resetErrors={resetErrors}
          setHasFreshSelection={setHasFreshSelection}
          setIsQuestionExiting={setIsQuestionExiting}
        />
      ) : shouldDisplayPreviousQuestion &&
        previousQuestionId &&
        fullPreviousQuestion ? (
        <>
          {/* Case 2: Previous question is INFO - display it with current question */}
          <KnowledgebaseQuestionAndInfoQuestion
            infoQuestionId={previousQuestionId}
            normalQuestionId={currentQuestionId}
            showErrors={showErrors}
            invalidQuestions={invalidQuestions}
            resetErrors={resetErrors}
            setHasFreshSelection={setHasFreshSelection}
            setIsQuestionExiting={setIsQuestionExiting}
          />
        </>
      ) : (
        <>
          {/* Case 3: Normal question - display only current question */}
          <KnowledgebaseQuestion
            key={currentQuestionId}
            extId={currentQuestionId}
            currentPage={currentPage}
            error={showErrors && invalidQuestions.includes(currentQuestionId)}
            resetErrors={resetErrors}
            onFreshSelection={() => setHasFreshSelection(true)}
            style={{ animationDelay: `${100}ms` }}
          />
        </>
      )}
    </>
  );
};
